import { ToolbarButton } from './ToolbarButton';
import { SceneActions } from '../actions/SceneActions';
import { Stats } from '../utils/Stats';

export class ToolbarButtonDelete extends ToolbarButton {
    public componentWillMount(): void {
        this.setState({active: false});
    }

    protected onClick = (): void => {
        SceneActions.deleteSelectedElements();
        Stats.sendEvent({
            category: 'Interaction',
            action: 'delete',
            label: null
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ToolbarButtonDelete.tsx